import { useLazyQuery } from "@apollo/client";
import { Sale as SaleModel } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_SALE } from "../../../sales/utils";
import useOnline from "@towersystems/roam-common-native/lib/utilities/use-online";
import { useInterval } from "../../../../utilities/use-interval";
import { useSaleControllerProvider } from "../../utils/sale-controller";
import React from "react";
import { useWithAppState } from "@towersystems/roam-common-native";

export interface ValidateActiveSaleProps {
  interval?: number;
  runImmediately?: boolean;
}

// Fetch the active sale from the server, and if the status is not "active",
// remove the sale from the controller
export const ValidateActiveSale = ({
  interval = 1000 * 60,
  runImmediately = false,
}: ValidateActiveSaleProps) => {
  const { sale } = useSaleControllerProvider();
  const { updateAppState } = useWithAppState();
  const online = useOnline();

  const [q] = useLazyQuery<{
    sale: SaleModel;
  }>(QUERY_SALE);

  const callback = async () => {
    if (online && sale && sale.externalId) {
      try {
        const result = await q({ variables: { id: sale.externalId } });
        if (result.error && result.error.message === "error.not-found") {
          updateAppState({ localSaleId: undefined });
          return;
        }

        if (!result?.data) {
          return;
        }

        if (
          [
            "TRANSFERRED",
            "CANCELLED",
            "QUOTE_CANCELLED",
            "INVOICE_CANCELLED",
            "LAYBY_CANCELLED",
            "LAYBY_CLOSED",
            "INVOICE_CLOSED",
            "QUOTE_CLOSED",
            "CLOSED",
          ].includes(result.data.sale.state)
        ) {
          updateAppState({ localSaleId: undefined });
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  React.useEffect(() => {
    if (runImmediately) {
      callback();
    }
  }, []);

  useInterval({
    callback,
    delay: interval,
  });

  return null;
};
